import React from "react";

import "./RefreshButton.scss";

export interface IRefreshButtonProps {
  title?: string;
  onClick?(): void;
}

const RefreshButton: React.FC<React.PropsWithChildren<IRefreshButtonProps>> = ({
  title,
  onClick,
}) => {
  return (
    <button
      className="c-refresh-button"
      title={title}
      onClick={onClick}
      tabIndex={0}
    >
      <span className="icon-sync1" />
    </button>
  );
};

export default RefreshButton;
